// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1764":"e3121d23a682bfde","4841":"b39dbd97004bc4b5","5233":"c796f0bc88917655","6178":"589437e8487c0aac"}[chunkId] + ".css";
};